import { render, staticRenderFns } from "./AudioPreviewSlim.vue?vue&type=template&id=52137fc0"
import script from "./AudioPreviewSlim.vue?vue&type=script&lang=js"
export * from "./AudioPreviewSlim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports